import { Card, Select } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 20px;
  font-size: 14px;
`;

export const ContainerLayout = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: #fff;
`;

export const TitleCofirm = styled.div``;

export const NumericColor = styled.span`
  color: #096dd9;
`;

export const DeselectTransp = styled.span`
  margin-left: 5px;
`;

export const BR = styled.div`
  margin-top: 5%;
`;

export const NameStrong = styled.strong`
  color: #595959;
`;

export const NameTransp = styled.strong`
  padding-left: 1%;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
`;

export const Btn = styled.div`
  display: inline;
  padding-left: 10px;
`;

export const SpaceDiv = styled.strong`
  display: block;
  font-style: normal;
  font-size: 16px;
  color: #595959;
  margin-left: 38%;
`;

export const Div = styled.div`
  margin-top: 1%;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #595959;
`;

export const IconColor = styled.span`
  color: #faad14;
  font-size: 20px;
  padding-right: 10px;
`;

export const CardAlert = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  width: 100%;
  background: #fffdf5;
  border: 1px solid #ffe58f;
  box-sizing: border-box;
  border-radius: 3px;
`;

export const TextAlert = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #595959;
  text-align: justify;
  text-justify: inter-word;
`;

export const Footer = styled.strong`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #595959;
  margin-right: 10px;
`;

export const Value = styled.strong`
  font-style: normal;
  font-size: 16px;
  color: #595959;
`;

export const Total = styled.div`
  padding: 10px;
  direction: rtl;
`;

export const Line = styled.div`
  position: static;
  width: 100%;
  height: 0px;
  left: 24px;
  top: 523px;
  border: 1px solid #d9d9d9;
  margin-bottom: 10px;
  margin-top: 15px;
`;

export const End = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
`;

export const StylePagador = styled.span`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
`;

export const ModalTransp = styled.div`
  p {
    color: ${(props) => props.theme.colors.textPrimary};
  }
`;

export const CardTransp = styled(Card)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  position: static;
  width: 100%;
  height: 72px;
  left: 0px;
  top: 102px;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  border-radius: 3px;
`;

export const TranspSelect = styled.span`
  flex: none;
  order: 3;
  align-self: stretch;
  flex-grow: 0;
`;

export const EditTransp = styled.span`
  position: absolute;
  margin-left: 68%;
  margin-top: 2%;
`;

export const Endereco = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #bfbfbf;
`;

export const EndEntrega = styled.strong`
  font-style: normal;
  font-size: 14px;
  line-height: 22px;
`;

export const TranspIcon = styled.span`
  position: absolute;
  left: 85%;

  .ant-btn .anticon {
    color: ${(props) => props.theme.colors.btnEdit};
  }
`;
